module.exports = __webpack_public_path__ + "static/img/37-2.1d5f6a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/37-2.jpg
// module id = mdPl
// module chunks = 0